<template>
  <div class="font-inter w- h-[1040px] bg-[#FFFFFF] rounded-t-[20px] mt-3">
    <HeaderComponent page-title="Project Details" />
    <div v-if="isLoading" class="flex justify-center items-center py-20">
      <div
        class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"
      ></div>
    </div>

    <div v-else-if="!isLoading && project.project_id" class="font-inter">
      <div v-if="isAdmin || isTalent || isManager" class=" ">
        <div
          class="border-grayLight space-y-6 py-6 h-auto justify-between bg-white px-8 text-grayDark rounded"
        >
          <div class="flex justify-between my-6">
            <div class="">
              <div class="flex items-center gap-3 mb-4">
                <div class="flex items-center">
                  <input
                    v-if="editingName"
                    v-model="projectName"
                    @blur="saveProjectName"
                    @keyup.enter="saveProjectName"
                    type="text"
                    class="text-2xl font-bold border border-gray-300 rounded p-2"
                  />
                  <h1
                    v-else
                    class="text-[20px] font-bold text-primaryDarkBg cursor-pointer"
                    @click="enableEditName"
                  >
                    {{ project.project_name }}
                  </h1>
                </div>
                <!-- <p
                  class="flex items-center space-x-2 text-[14px] text-gray-700 text-bodyText px-2 py-1 bg-[#E5E7ED] rounded-full cursor-pointer hover:bg-[#d0d3da]"
                >
                  UI/UX Design
                </p> -->
                <!-- <img
                  src="@/assets/projects/options.svg"
                  alt="Options"
                  class="h-6 cursor-pointer"
                /> -->
              </div>

              <div class="flex items-start space-x-2">
                <textarea
                  v-if="editingDescription"
                  v-model="projectDescription"
                  @blur="saveProjectDescription"
                  @keyup.enter="saveProjectDescription"
                  class="w- h-full min-h-[100px] text-[16px] border border-gray-300 rounded p-2 resize-none"
                ></textarea>
                <p
                  v-else
                  class="text-[14px] w-full [860px] cursor-pointer"
                  @click="enableEditDescription"
                >
                  {{ project.description }}
                </p>
              </div>
            </div>
            <div class="flex gap-4">
              <button
                @click="goToPublicProject(project.project_id)"
                class="flex gap-2 border-grayLight border-[1px] hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 items-center rounded-[8px] h-[42px]"
              >
                See Public View
              </button>
              <button
                @click="openProjectSettingsModal"
                class="flex gap-2 bg-primaryDarkBg hover:bg-primaryDark text-white text-[14px] font-medium px-3 py-3 items-center rounded-[8px] h-[42px]"
              >
                <img
                  src="@/assets/projects/setting-filter.svg"
                  alt="User icon"
                  class="h-4"
                />
                Project Settings
              </button>
            </div>
          </div>
          <TabComponent
            :tabs="projectDetailsTabs"
            v-model="activeProjectDetailsTab"
            :compact="false"
          />

          <!-- Loading indicator -->
          <!-- <div v-if="isLoading" class="flex justify-center items-center py-20">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"></div>
    </div> -->
          <div
            v-if="activeProjectDetailsTab === 'Tasks'"
            class="flex ml-auto justify-between mb-7 space-x-6 py-1 text-[14px] rounded-[6px] items-center"
          >
            <div class="flex gap-4 items-center">
              <div class="flex gap-4">
                <p class="flex text-[13px] items-center gap-2 rounded-[6px]">
                  <img src="@/assets/projects/filter.svg" alt="Icon" class="" />
                  Filters
                </p>

                <div class="flex items-center gap-4 text-grayDark">
                  <!-- Status Filter -->
                  <div ref="dropdown" @click="stopEventPropagation">
                    <div
                      class="flex items-center gap-2 px-2 py-1 border border-grayLight rounded-[8px] cursor-pointer"
                      @click="toggleStatusDropdown"
                    >
                      {{ selectedStatus || "Status" }}
                      <img
                        src="@/assets/projects/chevron-down.svg"
                        alt="Icon"
                      />
                    </div>
                    <div
                      v-if="showStatusDropdown"
                      class="absolute bg-white border rounded-[8px] shadow mt-2"
                    >
                      <ul>
                        <li
                          v-for="task_status in statuses"
                          :key="task_status"
                          @click="setStatusFilter(task_status)"
                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        >
                          {{ task_status }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <!-- Talent Filter (Modal-based) -->
                  <div ref="dropdown" @click="stopEventPropagation">
                    <div
                      class="flex items-center gap-2 px-2 py-1 border border-grayLight rounded-[8px] cursor-pointer"
                      @click="openModal"
                    >
                      {{ globalSelectedTalent || "Talent" }}
                      <img
                        src="@/assets/projects/chevron-down.svg"
                        alt="Dropdown Icon"
                      />
                    </div>
                  </div>

                  <!-- Date Filter -->
                  <!-- <div
                    class="relative"
                    ref="dropdown"
                    @click="stopEventPropagation"
                  >
                    <div
                      class="flex items-center gap-2 px-2 py-1 border border-grayLight rounded-[8px] cursor-pointer"
                      @click="toggleDateDropdown"
                    >
                      <span class="text-[14px] text-gray-700">
                        {{
                          selectedDateRange.start
                            ? `${selectedDateRange.start} - ${selectedDateRange.end}`
                            : "Date"
                        }}
                      </span>
                      <img
                        src="@/assets/projects/chevron-down.svg"
                        alt="Dropdown Icon"
                      />
                    </div>
                    <div
                      v-if="showDateDropdown"
                      class="absolute bg-white border border-grayLight rounded-[8px] shadow-lg mt-2 w-[250px] p-4"
                    >
                      <div class="space-y-3">
                        <div>
                          <label
                            for="start-date"
                            class="block text-[12px] font-medium text-gray-700"
                            >Start Date</label
                          >
                          <input
                            id="start-date"
                            type="date"
                            v-model="selectedDateRange.start"
                            class="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primaryDark focus:border-primaryDark text-[14px] px-2 py-1"
                          />
                        </div>
                        <div>
                          <label
                            for="end-date"
                            class="block text-[12px] font-medium text-gray-700"
                            >End Date</label
                          >
                          <input
                            id="end-date"
                            type="date"
                            v-model="selectedDateRange.end"
                            class="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primaryDark focus:border-primaryDark text-[14px] px-2 py-1"
                          />
                        </div>
                      </div>
                      <div class="flex justify-end mt-3">
                        <button
                          @click="applyDateFilter"
                          class="px-4 py-2 bg-primaryDark text-white rounded-md hover:bg-primaryDark hover:text-white text-[14px]"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div> -->

                  <button
                    @click="showDateFilter = true"
                    class="px-3 py-1 border rounded-[8px] flex items-center"
                  >
                    <span v-if="!globalStartDate && !globalEndDate">Date</span>
                    <span v-else class="text-bodyText">
                      Date range
                      <span class="text-grayDark">
                        {{ formatDateForDisplay(globalStartDate) }}
                        {{
                          globalEndDate
                            ? " - " + formatDateForDisplay(globalEndDate)
                            : ""
                        }}
                      </span>
                    </span>
                  </button>

                  <DateRangePicker
                    :isOpen="showDateFilter"
                    :initialStartDate="globalStartDate"
                    :initialEndDate="globalEndDate"
                    @close="showDateFilter = false"
                    @apply="applyGlobalDateFilter"
                  />
                </div>
              </div>
              <div class="h-6 w-[1px] bg-grayLight"></div>

              <div class="flex gap-4">
                <!-- <button
                  v-if="isManager || isAdmin"
                  @click="openSideMenu"
                  class="flex gap-2 border-grayLight border-[1px] text-grayDark text-[13px] font-medium px-3 py-3 items-center rounded-[8px] h-[30px]"
                >
                  <img
                    src="@/assets/tasks/add.svg"
                    alt="User icon"
                    class="h-4"
                  />
                  Add Talent
                </button> -->
                <button
                  @click="openCreateTaskModal"
                  :disabled="taskLimit && taskLimit.is_limit_reached"
                  class="flex gap-2 bg-[#EEEEEE] text-grayDark text-[13px] font-medium px-3 py-3 items-center rounded-[8px] h-[30px]"
                >
                  <img
                    src="@/assets/tasks/add.svg"
                    alt="User icon"
                    class="h-4"
                  />
                  New Task
                </button>
              </div>
            </div>
            <div class="flex space-x-3">
              <div
                @click="viewMode = 'list'"
                @mouseover="isListHovered = true"
                @mouseleave="isListHovered = false"
                :class="[
                  'flex w-full space-x-2 py-1 px-2 text-[14px] rounded-[6px] cursor-pointer transition-colors',
                  'bg-[#F2F4F7]',
                ]"
              >
                <svg
                  v-if="!isListHovered && viewMode !== 'list'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 6.00002H20M4 6.01002L4.01 5.99902M4 12.01L4.01 11.999M4 18.01L4.01 17.999M8 12H20M8 18H20"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <svg
                  v-else
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#4C4D4F"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="20" height="20" rx="3.33333" fill="#222222" />
                  <path
                    d="M6.66659 4.99986H16.6666M3.33325 5.00819L3.34159 4.99902M3.33325 10.0082L3.34159 9.99902M3.33325 15.0082L3.34159 14.999M6.66659 9.99986H16.6666M6.66659 14.9999H16.6666"
                    stroke="white"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <!-- <div
                @click="viewMode = 'timeline'"
                @mouseover="isTimelineHovered = true"
                @mouseleave="isTimelineHovered = false"
                :class="[
                  'flex w-full space-x-2 py-1 px-2 text-[14px] rounded-[6px] cursor-pointer transition-colors',
                  'bg-[#F2F4F7]',
                ]"
              >
                <svg
                  v-if="!isTimelineHovered && viewMode !== 'timeline'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.85637 16.5C5.85637 16.8107 6.10821 17.0625 6.41887 17.0625H10.8323C11.1429 17.0625 11.3947 16.8107 11.3947 16.5C11.3947 16.1893 11.1429 15.9375 10.8322 15.9375H6.41887C6.10821 15.9375 5.85637 16.1893 5.85637 16.5ZM12.6064 7.5C12.6064 7.81066 12.8582 8.0625 13.1689 8.0625H17.5822C17.8929 8.0625 18.1447 7.81066 18.1447 7.5C18.1447 7.18934 17.8929 6.9375 17.5822 6.9375H13.1689C12.8582 6.9375 12.6064 7.18934 12.6064 7.5ZM9.23137 12C9.23137 12.3107 9.48321 12.5625 9.79387 12.5625H14.2072C14.5179 12.5625 14.7697 12.3107 14.7697 12C14.7697 11.6893 14.5179 11.4375 14.2072 11.4375H9.79387C9.48321 11.4375 9.23137 11.6893 9.23137 12ZM5.25 21C4.00736 21 3 19.9926 3 18.75V5.25C3 4.00736 4.00736 3 5.25 3H18.75C19.9926 3 21 4.00736 21 5.25V18.75C21 19.9926 19.9926 21 18.75 21H5.25ZM4.125 17.625C4.125 18.8676 5.13236 19.875 6.375 19.875H17.625C18.8676 19.875 19.875 18.8676 19.875 17.625V6.375C19.875 5.13236 18.8676 4.125 17.625 4.125H6.375C5.13236 4.125 4.125 5.13236 4.125 6.375V17.625Z"
                    fill="#667085"
                  />
                </svg>

                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#4C4D4F"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 17H11C11.2833 17 11.521 16.904 11.713 16.712C11.905 16.52 12.0007 16.2827 12 16C11.9993 15.7173 11.9033 15.48 11.712 15.288C11.5207 15.096 11.2833 15 11 15H7C6.71667 15 6.47933 15.096 6.288 15.288C6.09667 15.48 6.00067 15.7173 6 16C5.99933 16.2827 6.09533 16.5203 6.288 16.713C6.48067 16.9057 6.718 17.0013 7 17ZM10 13H14C14.2833 13 14.521 12.904 14.713 12.712C14.905 12.52 15.0007 12.2827 15 12C14.9993 11.7173 14.9033 11.48 14.712 11.288C14.5207 11.096 14.2833 11 14 11H10C9.71667 11 9.47933 11.096 9.288 11.288C9.09667 11.48 9.00067 11.7173 9 12C8.99933 12.2827 9.09533 12.5203 9.288 12.713C9.48067 12.9057 9.718 13.0013 10 13ZM13 9H17C17.2833 9 17.521 8.904 17.713 8.712C17.905 8.52 18.0007 8.28267 18 8C17.9993 7.71733 17.9033 7.48 17.712 7.288C17.5207 7.096 17.2833 7 17 7H13C12.7167 7 12.4793 7.096 12.288 7.288C12.0967 7.48 12.0007 7.71733 12 8C11.9993 8.28267 12.0953 8.52033 12.288 8.713C12.4807 8.90567 12.718 9.00133 13 9ZM5 21C4.45 21 3.97933 20.8043 3.588 20.413C3.19667 20.0217 3.00067 19.5507 3 19V5C3 4.45 3.196 3.97933 3.588 3.588C3.98 3.19667 4.45067 3.00067 5 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V19C21 19.55 20.8043 20.021 20.413 20.413C20.0217 20.805 19.5507 21.0007 19 21H5Z"
                    fill="#222222"
                  />
                </svg>
              </div> -->

              <!-- <div
                @click="viewMode = 'grid'"
                @mouseover="isGridHovered = true"
                @mouseleave="isGridHovered = false"
                :class="[
                  'flex w-full space-x-2 py-1 px-2 text-[14px] rounded-[6px] cursor-pointer transition-colors',
                  'bg-[#F2F4F7]',
                ]"
              >
                <svg
                  v-if="!isGridHovered && viewMode !== 'grid'"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5003 18.9587H7.50033C2.97533 18.9587 1.04199 17.0253 1.04199 12.5003V7.50033C1.04199 2.97533 2.97533 1.04199 7.50033 1.04199H12.5003C17.0253 1.04199 18.9587 2.97533 18.9587 7.50033V12.5003C18.9587 17.0253 17.0253 18.9587 12.5003 18.9587ZM7.50033 2.29199C3.65866 2.29199 2.29199 3.65866 2.29199 7.50033V12.5003C2.29199 16.342 3.65866 17.7087 7.50033 17.7087H12.5003C16.342 17.7087 17.7087 16.342 17.7087 12.5003V7.50033C17.7087 3.65866 16.342 2.29199 12.5003 2.29199H7.50033Z"
                    fill="#4C4D4F"
                  />
                  <path
                    d="M10 18.9587C9.65833 18.9587 9.375 18.6753 9.375 18.3337V1.66699C9.375 1.32533 9.65833 1.04199 10 1.04199C10.3417 1.04199 10.625 1.32533 10.625 1.66699V18.3337C10.625 18.6753 10.3417 18.9587 10 18.9587Z"
                    fill="#4C4D4F"
                  />
                  <path
                    d="M18.3337 10.625H1.66699C1.32533 10.625 1.04199 10.3417 1.04199 10C1.04199 9.65833 1.32533 9.375 1.66699 9.375H18.3337C18.6753 9.375 18.9587 9.65833 18.9587 10C18.9587 10.3417 18.6753 10.625 18.3337 10.625Z"
                    fill="#4C4D4F"
                  />
                </svg>
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#4C4D4F"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.25 12.75V22H7.81C4.17 22 2 19.83 2 16.19V12.75H11.25Z"
                  />
                  <path
                    d="M22 7.81V11.25H12.75V2H16.19C19.83 2 22 4.17 22 7.81Z"
                  />
                  <path d="M11.25 2V11.25H2V7.81C2 4.17 4.17 2 7.81 2H11.25Z" />
                  <path
                    d="M22 12.75V16.19C22 19.83 19.83 22 16.19 22H12.75V12.75H22Z"
                  />
                </svg>
              </div> -->
            </div>
          </div>
        </div>

        <div
          v-if="activeProjectDetailsTab === 'Contributors'"
          class="flex items-center mb-7 px-8"
        >
          <!-- Filters Label -->
          <div class="flex items-center gap-2 text-sm text-gray-700">
            <img src="@/assets/projects/filter.svg" alt="Filter icon" class="h-4 w-4" />
            Filters
          </div>
          
          <!-- Role Dropdown -->
          <div class="relative ml-4">
            <select 
              v-model="selectedRoleFilter"
              @change="handleRoleFilterChange"
              class="appearance-none w-28 px-3 py-2 pr-8 border border-gray-300 rounded-lg text-sm text-gray-700 bg-white hover:bg-gray-50 cursor-pointer focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              <option value="">Role</option>
              <option v-for="role in projectRoles" :key="role" :value="role">
                {{ capitalize(role) }}
              </option>
            </select>
            <img src="@/assets/projects/chevron-down.svg" alt="Dropdown" class="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 pointer-events-none" />
          </div>
          
          <!-- Skills Dropdown -->
          <div class="relative ml-3">
            <select 
              v-model="selectedSkillFilter"
              @change="handleSkillFilterChange"
              class="appearance-none w-28 px-3 py-2 pr-8 border border-gray-300 rounded-lg text-sm text-gray-700 bg-white hover:bg-gray-50 cursor-pointer focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              <option value="">Skills</option>
              <option v-for="skill in projectSkills" :key="skill" :value="skill">
                {{ capitalize(skill) }}
              </option>
            </select>
            <img src="@/assets/projects/chevron-down.svg" alt="Dropdown" class="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 pointer-events-none" />
          </div>
          
          <!-- Divider Line -->
          <div class="h-8 w-[1px] bg-[#EEEEEE] mx-3"></div>
          
          <!-- Add Talent Button -->
          <button
            v-if="isManager || isAdmin"
            @click="openSideMenu"
            class="flex items-center gap-2 px-4 py-2 bg-[#EEEEEE] rounded-lg text-sm hover:bg-gray-200"
            style="color: #667085;"
          >
            <img src="@/assets/tasks/add.svg" alt="Add icon" class="h-4 w-4" style="filter: brightness(0) saturate(100%) invert(45%) sepia(8%) saturate(557%) hue-rotate(177deg) brightness(92%) contrast(88%);" />
            Add Talent
          </button>
          
          <button
            v-if="isManager || isAdmin"
            @click="openAddManagerModal"
            class="flex items-center gap-2 px-4 py-2 bg-[#EEEEEE] rounded-lg text-sm hover:bg-gray-200 ml-2"
            style="color: #667085;"
          >
            <img src="@/assets/tasks/add.svg" alt="Add icon" class="h-4 w-4" style="filter: brightness(0) saturate(100%) invert(45%) sepia(8%) saturate(557%) hue-rotate(177deg) brightness(92%) contrast(88%);" />
            Add Manager
          </button>
        </div>

        <AboutProject v-if="activeProjectDetailsTab === 'About'" />
        <AISummary
          v-if="
            (isManager || isAdmin) && activeProjectDetailsTab === 'AI Summary'
          "
          :globalSelectedTalent="globalSelectedTalent"
          :globalSelectedTalentId="globalSelectedTalentId"
          :globalStartDate="globalStartDate"
          :globalEndDate="globalEndDate"
          @update-global-filters="updateGlobalFiltersFromChild"
        />
        <ActivityData
          v-if="activeProjectDetailsTab === 'Activities'"
          :projectId="project.project_id"
          :globalSelectedTalent="globalSelectedTalent"
          :globalSelectedTalentId="globalSelectedTalentId"
          :globalStartDate="globalStartDate"
          :globalEndDate="globalEndDate"
          @update-global-filters="updateGlobalFiltersFromChild"
        />
        <ContributorsTable
          v-if="activeProjectDetailsTab === 'Contributors'"
          class="mx-8"
          :projectId="project.project_id"
          :selectedRole="selectedRoleFilter"
          :selectedSkill="selectedSkillFilter"
        />
        <ResourcesComponent
          v-if="activeProjectDetailsTab === 'Resources'"
          :projectId="project.project_id"
          class="mx-8"
        />

        <SeedBreakdownChart
          v-if="activeProjectDetailsTab === 'Seed Breakdown'"
          class="mx-8"
          :projectId="project.project_id"
        />
        <div class="border-grayLight border-t-[1px]">
          <div v-if="activeProjectDetailsTab === 'Tasks'">
            <div class="px-8 space-y- rounded mt-8" v-if="viewMode === 'list'">
              <TaskTable
                ref="taskTable"
                :talentId="talentId"
                :talentName="talentName"
                :talentEmail="talentEmail"
                :selectedStatus="selectedStatus"
                :selectedAssignee="selectedAssignee"
                :startDate="startDate"
                :endDate="endDate"
                :globalSelectedTalent="globalSelectedTalent"
                :globalSelectedTalentId="globalSelectedTalentId"
                @apply="applyGlobalDateFilter"
                @open-task-modal="openCreateTaskModal"
                @rename-task-modal="openRenameTaskModal"
                @edit-task-modal="openEditTaskModal"
                :taskLimit="taskLimit"
              />
            </div>
            <div class="" v-else-if="viewMode === 'timeline'">
              <GoalTimeline />
            </div>
            <div v-else>
              <TaskGrid />
            </div>
          </div>
          <div
            v-if="activeProjectDetailsTab === 'Investors'"
            class="px-8 space-y- rounded mt-8"
          >
            <InvestorTable
              :investors="investors"
              :isLoading="isLoading"
              @approve-investor="approveInvestor"
              @deny-investor="denyInvestor"
            />
          </div>
        </div>

        <CreateTaskModal
          ref="createTaskModal"
          :projectId="project.project_id"
          :showModal="showCreateTaskModal"
          :talents="talents"
          :selectedTalent="talent"
          :members="members"
          :teams="teams"
          :talentId="talentId"
          :talentName="talentName"
          :talentEmail="talentEmail"
          :teamName="teamName"
          :isTaskEdit="isTaskEdit"
          :prefilledTask="prefilledTask"
          :TaskAssignedTo="TaskAssignedTo"
          @close="closeCreateTaskModal"
          @refresh-tasks="updateTaskList"
          @task-created="handleTaskCreated"
        />
        <RenameTaskModal
          v-if="showRenameTaskModal"
          :showModal="showRenameTaskModal"
          :task="selectedTaskForRename"
          @close="closeRenameTaskModal"
          @task-renamed="fetchTasks(project.project_id)"
        />
        <ProjectSettingsModal
          :showModal="showProjectSettingsModal"
          :project="project"
          @close="closeProjectSettingsModal"
        />
        <AddProjectManagerModal
          :showModal="showAddManagerModal"
          :projectId="project.project_id"
          :projectName="project.project_name"
          @close="closeAddManagerModal"
          @manager-added="handleManagerAdded"
        />

        <!-- Talent Selection Modal -->
        <Teleport to="body">
          <div
            v-if="isModalOpen"
            class="fixed inset-0 flex items-center justify-center z-50"
          >
            <!-- Backdrop -->
            <div
              class="absolute inset-0 bg-black bg-opacity-50"
              @click="closeModal"
            ></div>

            <!-- Modal -->
            <div
              class="bg-white max-w-lg w-full max-h-[90vh] p-6 rounded-lg shadow-lg relative z-50 flex flex-col"
            >
              <!-- Header -->
              <div
                class="flex justify-between items-center border-b pb-3 sticky top-0 bg-white z-10"
              >
                <h3 class="text-lg font-medium">Search Talent Name</h3>
                <button
                  @click="closeModal"
                  class="h-8 w-8 rounded-full flex items-center justify-center bg-gray-100"
                >
                  <img
                    src="@/assets/tasks/iconoir_cancel.svg"
                    alt="Close"
                    class="h-5 w-5"
                  />
                </button>
              </div>

              <!-- Search Input -->
              <div class="relative mt-4 sticky top-[50px] bg-white z-10">
                <input
                  v-model="searchQuery"
                  type="text"
                  class="w-full h-11 px-3 pl-10 rounded-md shadow-sm bg-gray-100 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  placeholder="Enter a keyword"
                  required
                />
                <button
                  class="absolute top-1/2 left-3 transform -translate-y-1/2 cursor-pointer"
                >
                  <img
                    src="@/assets/projects/search-normal.svg"
                    alt="Search"
                    class="h-5 w-5"
                  />
                </button>
              </div>

              <!-- Scrollable Content -->
              <div class="py-4 overflow-y-auto flex-1">
                <div class="mb-4">
                  <div
                    class="flex gap-3 py-4 whitespace-nowrap cursor-pointer hover:bg-gray-100 p-2 rounded border-b border-gray-200"
                    @click="clearTalentFilter"
                  >
                    <div
                      class="w-[42px] h-[42px] text-[14px] flex items-center justify-center rounded-full text-gray-600 font-semibold bg-gray-200"
                    >
                      All
                    </div>

                    <div class="text-[13px]">
                      <p class="font-medium text-gray-900">All Talents</p>
                      <p class="text-grayDark">
                        Show tasks from all team members
                      </p>
                    </div>
                  </div>
                </div>

                <div v-if="filteredMembers.length > 0" class="space-y-3">
                  <div
                    v-for="member in filteredMembers"
                    :key="member.project_member_id"
                    class="relative"
                  >
                    <div
                      class="flex gap-3 py-4 whitespace-nowrap cursor-pointer hover:bg-gray-100 p-2 rounded"
                      @click="selectTalent(member)"
                    >
                      <div
                        class="w-[42px] h-[42px] text-[14px] flex items-center justify-center rounded-full text-white font-semibold bg-[#A3DB7D]"
                      >
                        {{
                          getInitials(
                            member.talent_first_name,
                            member.talent_last_name
                          )
                        }}
                      </div>

                      <div class="text-[13px]">
                        <p class="font-medium text-gray-900">
                          {{ capitalize(member.talent_first_name) }}
                          {{ capitalize(member.talent_last_name) }}
                        </p>
                        <p class="text-grayDark">{{ member.talent_email }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center text-gray-500 py-6">
                  No talent found in project
                </div>
              </div>
            </div>
          </div>
        </Teleport>
      </div>

      <div
        v-if="isSideMenuOpen"
        class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"
        @click="closeSideMenu"
      ></div>

      <div
        v-if="isSideMenuOpen"
        class="fixed top-0 right-0 w-[543px] h-full bg-white shadow-lg z-50 transform transition-transform duration-300 text-[14px]"
      >
        <div class="space-y-4">
          <!-- Header -->
          <div
            class="py-4 px-4 flex justify-between items-center border-b-[1px] border-grayLight"
          >
            <h3 class="text-lg font-medium">Add talent to project</h3>
            <div
              @click="closeSideMenu"
              class="bg-[#FAFBFC] h-8 w-8 rounded-full flex items-center justify-center"
            >
              <img
                src="@/assets/tasks/iconoir_cancel.svg"
                alt="Close"
                class="h-6 cursor-pointer"
              />
            </div>
          </div>
          
          <!-- Current Team Section -->
          <div class="p-4 flex gap-[29px]">
            <p class="text-[14px] font-medium mb-4">Current Team</p>
            <div class="space-y-3">
              <!-- Iterate Over Members -->
              <div
                v-for="(member, index) in members"
                :key="member.project_member_id"
                class="relative"
              >
                <input
                  v-model="member.talent_first_name"
                  class="w-[382px] h-[44px] px-3 py-2 pr-12 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                  placeholder="Enter member name"
                  required
                />
                <!-- Cancel Button -->
                <div
                  @click="removeMember(index)"
                  class="absolute top-1/2 right-6 transform -translate-y-1/2 bg-[#F6F8F9] h-5 w-5 flex items-center justify-center rounded-full cursor-pointer"
                >
                  <img
                    src="@/assets/tasks/iconoir_cancel.svg"
                    alt="Remove Member"
                    class="h-4"
                  />
                </div>
              </div>
            </div>
          </div>

          <p
            @click="emitOpenAddProjectMemberModal()"
            class="mx-4 flex justify-center items-center gap-2 text-center border-grayLight border-[1px] hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-5 py-3 rounded-[8px] h-[42px] cursor-pointer"
          >
            Add Talent
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
import HeaderComponent from "../HeaderComponent.vue";
import CreateTaskModal from "@/components/modals/CreateTaskModal.vue";
import TaskGrid from "./TaskGrid.vue";
import TaskTable from "./TaskTable.vue";
import GoalTimeline from "./GoalTimeline.vue";
import eventBus from "@/eventBus";
import SeedBreakdownChart from "../charts/SeedBreakdownChart.vue";
import AISummary from "@/components/project/AISummary.vue";
import ActivityData from "./ActivityData.vue";
import InvestorTable from "@/components/InvestorTable.vue";
import TabComponent from "../profiles/TabComponent.vue";
import { createTabStateManager } from "@/utils/tabStateManager";
import ContributorsTable from "@/components/project/assets/ContributorsTable.vue";
import ResourcesComponent from "@/components/project/assets/ResourcesComponent.vue";
import RenameTaskModal from "@/components/modals/RenameTaskModal.vue";
import AboutProject from "./AboutProject.vue";
import DateRangePicker from "../DateRangePicker.vue";
import ProjectSettingsModal from "../modals/ProjectSettingsModal.vue";
import AddProjectManagerModal from "../modals/AddProjectManagerModal.vue";

export default {
  name: "ProjectDetailsComponent",
  components: {
    HeaderComponent,
    CreateTaskModal,
    TaskTable,
    TaskGrid,
    GoalTimeline,
    SeedBreakdownChart,
    AISummary,
    ActivityData,
    InvestorTable,
    TabComponent,
    ContributorsTable,
    ResourcesComponent,
    RenameTaskModal,
    AboutProject,
    DateRangePicker,
    ProjectSettingsModal,
    AddProjectManagerModal,
  },
  data() {
    return {
      activeProjectDetailsTab:
        localStorage.getItem("activeProjectDetailsTab") || "Tasks",
      // projectDetailsTabs: this.getProjectTabs(),

      activeProjectInvestorTab:
        localStorage.getItem("activeProjectInvestorTab") || "About",
      investorTabs: ["About", "Activities", "Seed Breakdown", "Investors"],

      tabStateManager: null,
      projectDetailsTabStateManager: null,
      investorTabStateManager: null,

      // Storage listeners
      projectDetailsTabStorageListener: null,
      investorTabStorageListener: null,

      selectedStatus: "Status",
      selectedAssignee: null,

      // Shared state for filters across tabs
      globalSelectedTalent: null,
      globalSelectedTalentId: null,
      globalStartDate: "",
      globalEndDate: "",
      isModalOpen: false,
      searchQuery: "",

      isLoading: false,
      talentId: 0,
      talentEmail: "",
      teamName: "",
      talentName: "",
      TaskAssignedTo: 0,
      selectedProjectName: "",
      isListHovered: false,
      isTimelineHovered: false,
      isGridHovered: false,
      viewMode: "list",
      isSideMenuOpen: false,
      project: {
        start_date: "",
        end_date: "",
        project_id: "",
        project_name: "",
        description: "",
      },
      member: {
        project_member_id: "",
        project_id: "",
        talent_id: "",
        position: "",
        talent_user_id: "",
      },
      projectName: "",
      projectDescription: "",
      tasks: [],
      statuses: ["Status", "In Progress", "Completed", "Not Started", "Done"],
      talent: {
        talentEmail: "",
        talentName: "",
      },
      talents: [],
      teams: [],
      showAssigneeDropdown: false,
      showStatusDropdown: false,
      members: [],
      showTaskModal: false,
      showAddMemberModal: false,
      showCreateTaskModal: false,
      editingName: false,
      editingDescription: false,
      canJoinProject: false,
      canInvestProject: false,
      isApprovedMember: false,
      canCancelRequest: false,
      totalSeed: 0,
      todaySeed: 0,
      todaySeedPercentage: 0,
      investors: [],
      investorPercentages: [],

      showDateDropdown: false,
      prefilledTask: null,
      showRenameTaskModal: false,
      selectedTaskForRename: null,

      // Date range filter
      showDateFilter: false,
      startDate: "",
      endDate: "",
      isTaskEdit: false,
      showProjectSettingsModal: false,
      showAddManagerModal: false,

      taskLimit: null, // Store task creation limit

      projectRoles: [],
      projectSkills: [],
      selectedRoleFilter: '',
      selectedSkillFilter: '',
    };
  },
  watch: {
    "$route.params.projectId": {
      async handler(newProjectId, oldProjectId) {
        if (newProjectId && newProjectId !== oldProjectId) {
          await this.checkMembershipStatus();

          if (this.$route.name === "ProjectDetails") {
            this.fetchProject();
            this.fetchInvestors(newProjectId);
            this.fetchProjectMembers(newProjectId);
            this.fetchProjectTeams(newProjectId);
            this.fetchTalents(newProjectId);
            this.fetchTasks(newProjectId);
          }
        }
      },
      immediate: true,
    },

    activeProjectDetailsTab: {
      handler(newTab) {
        if (this.projectDetailsTabStateManager && newTab) {
          this.projectDetailsTabStateManager.setActiveTab(newTab);
          console.log("Main settings tab changed to:", newTab);
        }
      },
      immediate: false,
    },
    activeProjectInvestorTab: {
      handler(newTab) {
        if (this.investorTabStateManager && newTab) {
          this.investorTabStateManager.setActiveTab(newTab);
          console.log("Investor project tab changed to:", newTab);
        }
      },
      immediate: false,
    },
    // Reinitialize when user changes
    "$store.state.user": {
      handler(newUser, oldUser) {
        if (newUser && newUser !== oldUser) {
          this.initTabStates();
        }
      },
      deep: true,
    },

    selectedStatus: {
      handler(newStatus) {
        localStorage.setItem(
          `user_${this.currentUserId}_selectedStatus`,
          JSON.stringify(newStatus)
        );
      },
    },

    selectedAssignee: {
      handler(newAssignee) {
        if (newAssignee) {
          localStorage.setItem(
            `user_${this.currentUserId}_selectedAssignee`,
            JSON.stringify(newAssignee)
          );
        } else {
          localStorage.removeItem(
            `user_${this.currentUserId}_selectedAssignee`
          );
        }
      },
      deep: true,
    },
    // selectedDateRange: {
    //   handler(newDateRange) {
    //     const { start, end } = newDateRange;
    //     const formattedStartDate = start ? `${start}T00:00:00` : null;
    //     const formattedEndDate = end ? `${end}T23:59:59` : null;
    //     this.fetchTasks(
    //       this.project.project_id,
    //       formattedStartDate,
    //       formattedEndDate
    //     );
    //   },
    //   deep: true,
    // },

    // Replace the selectedDateRange watcher with:
    startDate: {
      handler() {
        this.applyDateRangeFilter();
      },
    },
    endDate: {
      handler() {
        this.applyDateRangeFilter();
      },
    },

    // Watch global filters to update local state and sync across tabs
    globalStartDate: {
      handler(newVal) {
        this.startDate = newVal;
      },
    },
    globalEndDate: {
      handler(newVal) {
        this.endDate = newVal;
      },
    },
    globalSelectedTalentId: {
      handler(newVal) {
        if (newVal && this.members.length > 0) {
          const talent = this.members.find((m) => m.talent_id === newVal);
          if (talent) {
            this.selectedAssignee = talent;
          }
        } else {
          this.selectedAssignee = null;
        }
      },
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isInvestor() {
      return this.$store.getters.isInvestor;
    },

    currentUserId() {
      const currentUser = this.$store.state.user;
      const userId = currentUser ? currentUser.user_id : "guest";
      return userId;
    },

    userIdentifier() {
      return this.user?.user_id || this.$store.state.user?.user_id || "default";
    },
    projectDetailsTabs() {
      const tabs = [
        "About",
        "Tasks",
        "Activities",
        "Contributors",
        "Resources",
        "Investors",
        "Seed Breakdown",
      ];
      if (this.isAdmin || this.isManager) {
        tabs.splice(2, 0, "AI Summary"); // Show it between Tasks and Activities
      }
      return tabs;
    },
    hasDateFilter() {
      return this.startDate || this.endDate;
    },
    hasAnyFilter() {
      return (
        this.filters.talent ||
        this.hasDateFilter ||
        this.selectedTimeFilter.value !== "all"
      );
    },
    filteredMembers() {
      if (!this.searchQuery) return this.members;

      const query = this.searchQuery.toLowerCase();
      return this.members.filter((member) => {
        const fullName =
          `${member.talent_first_name} ${member.talent_last_name}`.toLowerCase();
        const email = member.talent_email.toLowerCase();
        return fullName.includes(query) || email.includes(query);
      });
    },
  },
  methods: {
    closeProjectSettingsModal() {
      this.showProjectSettingsModal = false;
    },
    openProjectSettingsModal() {
      this.showProjectSettingsModal = true;
    },
    closeAddManagerModal() {
      this.showAddManagerModal = false;
    },
    openAddManagerModal() {
      this.showAddManagerModal = true;
    },
    handleManagerAdded(message) {
      this.$toast.success(message);
      this.fetchProjectMembers(this.project.project_id);
    },
    async fetchProjectRoles(projectId) {
      try {
        const response = await apiClient.get(`/web/projects/${projectId}/roles`);
        this.projectRoles = response.data.data || [];
      } catch (error) {
        console.error('Error fetching project roles:', error);
      }
    },
    async fetchProjectSkills(projectId) {
      try {
        const response = await apiClient.get(`/web/projects/${projectId}/skills`);
        this.projectSkills = response.data.data || [];
      } catch (error) {
        console.error('Error fetching project skills:', error);
      }
    },
    handleRoleFilterChange(event) {
      this.selectedRoleFilter = event.target.value;
    },
    handleSkillFilterChange(event) {
      this.selectedSkillFilter = event.target.value;
    },
    initTabStates() {
      this.initProjectDetailsTabState();
      this.initInvestorTabState();
    },

    initProjectDetailsTabState() {
      // Clean up previous listener
      if (this.projectDetailsTabStorageListener) {
        window.removeEventListener(
          "storage",
          this.projectDetailsTabStorageListener
        );
      }

      // Create user-specific storage key for main settings tabs
      const userSpecificKey = `projectDetailsComponent_${this.userIdentifier}`;

      // Create tab state manager
      this.projectDetailsTabStateManager = createTabStateManager(
        userSpecificKey,
        this.isInvestor ? "Tasks" : "Tasks", // Default tab based on user type
        this.getAvailableProjectDetailsTabs() // Get tabs based on user role
      );

      // Load saved tab
      const savedTab = this.projectDetailsTabStateManager.getActiveTab();
      console.log("Loaded main tab from localStorage:", savedTab);

      // Set the tab, but also check URL query parameter
      const urlTab = this.$route.query.section;
      if (urlTab && this.getAvailableProjectDetailsTabs().includes(urlTab)) {
        this.activeProjectDetailsTab = urlTab;
        this.projectDetailsTabStateManager.setActiveTab(urlTab);
      } else {
        this.activeProjectDetailsTab = savedTab;
      }

      // Listen for changes from other browser tabs/windows
      this.projectDetailsTabStorageListener = (e) => {
        if (e.key === userSpecificKey && e.newValue) {
          console.log("Main tab changed in another window:", e.newValue);
          this.activeProjectDetailsTab = e.newValue;
        }
      };

      window.addEventListener("storage", this.projectDetailsTabStorageListener);
    },

    // Initialize device settings sub-tab
    initInvestorTabState() {
      // Clean up previous listener
      if (this.investorTabStorageListener) {
        window.removeEventListener("storage", this.investorTabStorageListener);
      }

      // Create user-specific storage key for device settings tabs
      const userSpecificKey = `investorTabComponent_${this.userIdentifier}`;

      // Create tab state manager
      this.investorTabStateManager = createTabStateManager(
        userSpecificKey,
        "Active History", // Default device tab
        this.activeProjectInvestorTab
      );

      // Load saved tab
      const savedTab = this.investorTabStateManager.getActiveTab();
      console.log("Loaded device tab from localStorage:", savedTab);
      this.activeProjectInvestorTab = savedTab;

      // Listen for changes from other browser tabs/windows
      this.investorTabStorageListener = (e) => {
        if (e.key === userSpecificKey && e.newValue) {
          console.log("Device tab changed in another window:", e.newValue);
          this.activeProjectInvestorTab = e.newValue;
        }
      };

      window.addEventListener("storage", this.investorTabStorageListener);
    },

    getAvailableProjectDetailsTabs() {
      let tabs = [
        "About",
        "Tasks",
        "Activities",
        "Contributors",
        "Resources",
        "Investors",
        "Seed Breakdown",
      ];

      if (this.isAdmin || this.isManager) {
        tabs.splice(2, 0, "AI Summary"); // Show it between Tasks and Activities
      }

      // Add investment history tab for investors
      if (this.isInvestor) {
        tabs.push("investment_history");
      }

      return tabs;
    },

    // Update the settingsTabs computed property or data
    getSettingsTabs() {
      return this.getAvailableProjectDetailsTabs();
    },

    setActiveProjectInvestorTab(tab) {
      console.log("Setting active investor project tab to:", tab);
      this.activeProjectInvestorTab = tab;
      if (this.investorTabStateManager) {
        this.investorTabStateManager.setActiveProjectInvestorTab(tab);
      }
    },

    cleanupOldTabPreferences() {
      // Remove old non-user-specific keys
      const oldKeys = ["activeProjectDetailsTab", "activeProjectInvestorTab"];

      oldKeys.forEach((key) => {
        if (localStorage.getItem(key)) {
          localStorage.removeItem(key);
        }
      });

      // Clean up any orphaned user-specific keys (optional)
      const keysToCleanup = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (
          key &&
          key.startsWith("projectDetailsComponent_") &&
          !key.includes(`_${this.userIdentifier}`)
        ) {
          keysToCleanup.push(key);
        }
      }
      keysToCleanup.forEach((key) => localStorage.removeItem(key));
    },

    applyFiltersOnLoad() {
      eventBus.emit("applyFilters", {
        status: this.selectedStatus,
        assignee: this.selectedAssignee,
      });
    },
    // updateTaskList(newTasks) {
    //   if (newTasks && newTasks.length > 0) {
    //     this.tasks = newTasks;
    //   } else {
    //     this.fetchTasks();
    //   }
    // },
    updateTaskList(newTasks) {
      console.log("Updating task list with:", newTasks);
      if (newTasks && newTasks.length > 0) {
        this.tasks = [...newTasks]; // Create a new array to trigger reactivity
      } else {
        // this.fetchTasks(this.$route.params.projectId);
      }
    },
    async joinProject() {
      const projectId = this.$route.params.projectId;

      try {
        await apiClient.post(`/web/projects/${projectId}/join`);
        this.$toast.success("You have successfully sent a request to join the project!"); 
        this.checkMembershipStatus();
        // this.$router.push({ name: "ProjectDetails", params: { projectId } });
      } catch (error) {
        error.response?.data?.message;
        console.warn("Investor just joined the project.");
      }
    },
    setActiveTab(tab) {
      this.activeProjectDetailsTab = tab;
    },
    // setActiveInvestorTab(tab) {
    //   this.activeProjectInvestorTab = tab;
    // },
    capitalize(text) {
      if (!text) return "";
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    toggleStatusDropdown() {
      this.showStatusDropdown = !this.showStatusDropdown;
    },
    closeStatusDropdown() {
      this.showStatusDropdown = false;
    },
    setStatusFilter(task_status) {
      this.selectedStatus = task_status;
      this.showStatusDropdown = false;
      console.log("Selected task status updated to:", this.selectedStatus); // Debugging

      if (task_status) {
        localStorage.setItem("selectedStatus", JSON.stringify(task_status));
      } else {
        localStorage.removeItem("selectedStatus");
      }
    },
    closeDropdown() {
      this.showAssigneeDropdown = false;
    },
    stopEventPropagation(event) {
      event.stopPropagation();
    },
    toggleAssigneeDropdown() {
      this.showAssigneeDropdown = !this.showAssigneeDropdown;
    },
    setAssigneeFilter(assignee) {
      this.selectedAssignee = assignee;
      console.log(assignee);
      // Update the dropdown label
      this.showAssigneeDropdown = false;

      if (assignee) {
        localStorage.setItem("selectedAssignee", JSON.stringify(assignee));
      } else {
        localStorage.removeItem("selectedAssignee");
      }
    },
    // toggleDateDropdown() {
    //   this.showDateDropdown = !this.showDateDropdown;
    // },
    toggleDateFilter() {
      this.showDateFilter = !this.showDateFilter;
    },
    // applyDateFilter() {
    //   this.showDateDropdown = false;
    //   console.log("Selected date range:", this.selectedDateRange);
    // },

    // applyDateFilter(dateRange) {
    //   if (dateRange) {
    //     this.startDate = dateRange.startDate;
    //     this.endDate = dateRange.endDate;
    //   }
    //   this.showDateFilter = false;
    //   this.applyDateRangeFilter();
    // },

    // applyDateFilter(dateRange) {
    //   if (dateRange) {
    //     this.startDate = dateRange.startDate;
    //     this.endDate = dateRange.endDate;
    //   }
    //   this.showDateFilter = false;
    //   this.applyDateRangeFilter();
    //   this.saveFiltersToStorage();
    // },
    applyDateFilter(dateRange) {
      if (dateRange) {
        this.startDate = dateRange.startDate;
        this.endDate = dateRange.endDate;
      }
      this.showDateFilter = false;
      this.saveFiltersToStorage();
    },

    // Global date filter method for shared state
    applyGlobalDateFilter(dateRange) {
      if (dateRange) {
        this.globalStartDate = dateRange.startDate;
        this.globalEndDate = dateRange.endDate;
        // Also update local state for backwards compatibility
        this.startDate = dateRange.startDate;
        this.endDate = dateRange.endDate;
      }
      this.showDateFilter = false;
      this.saveGlobalFiltersToStorage();
    },

    applyDateRangeFilter() {
      if (!this.project.project_id) return;

      const formattedStartDate = this.startDate || null;
      const formattedEndDate = this.endDate || null;

      this.fetchTasks(
        this.project.project_id,
        formattedStartDate,
        formattedEndDate
      );
    },

    // Modal-related methods
    openModal() {
      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
      this.searchQuery = "";
    },

    selectTalent(talent) {
      this.globalSelectedTalent = `${this.capitalize(
        talent.talent_first_name
      )} ${this.capitalize(talent.talent_last_name)}`;
      this.globalSelectedTalentId = talent.talent_id;
      this.selectedAssignee = talent;
      this.closeModal();
      this.saveGlobalFiltersToStorage();
    },

    clearTalentFilter() {
      this.globalSelectedTalent = null;
      this.globalSelectedTalentId = null;
      this.selectedAssignee = null;
      this.closeModal();
      this.saveGlobalFiltersToStorage();
    },

    getInitials(firstName, lastName) {
      const firstInitial = firstName
        ? firstName.trim().charAt(0).toUpperCase()
        : "";
      const lastInitial = lastName
        ? lastName.trim().charAt(0).toUpperCase()
        : "";
      return `${firstInitial}${lastInitial}`;
    },

    // Method to handle filter updates from child components
    updateGlobalFiltersFromChild(filters) {
      if (filters.globalSelectedTalent !== undefined) {
        this.globalSelectedTalent = filters.globalSelectedTalent;
      }
      if (filters.globalSelectedTalentId !== undefined) {
        this.globalSelectedTalentId = filters.globalSelectedTalentId;
      }
      if (filters.globalStartDate !== undefined) {
        this.globalStartDate = filters.globalStartDate;
      }
      if (filters.globalEndDate !== undefined) {
        this.globalEndDate = filters.globalEndDate;
      }

      this.startDate = this.globalStartDate;
      this.endDate = this.globalEndDate;

      this.saveGlobalFiltersToStorage();
    },

    applyFilters() {
      console.log("Applying Filters:", this.filters);
    },
    openSideMenu(member) {
      this.selectedMember = member;
      this.isSideMenuOpen = true;
    },
    closeSideMenu() {
      this.isSideMenuOpen = false;
    },
    setViewMode(mode) {
      this.viewMode = mode;
    },
    emitOpenAddProjectMemberModal() {
      // Emit event with project ID and name
      eventBus.emit("openAddProjectMemberModal", {
        projectId: this.project.project_id,
        projectName: this.project.project_name,
      });
    },

    removeMember(index) {
      this.members.splice(index, 1); // Remove the member at the specified index
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const month = date.getMonth() + 1; // Months are zero-based
      const day = date.getDate();
      return `${month}/${day}`;
    },

    checkUserAccessAndRedirect() {
      // If user is not admin, manager, or talent, redirect to public view
      if (!this.isAdmin && !this.isManager && !this.isTalent) {
        const projectId = this.$route.params.projectId;
        this.goToPublicProject(projectId);
        return false;
      }
      return true;
    },

    async fetchProject() {
      this.isLoading = true;
      const projectId = this.$route.params.projectId;
      try {
        const response = await apiClient.get(`/web/projects/${projectId}`);
        this.project = response.data.data;
        this.projectName = this.project.project_name;
        // this.fetchTasks(projectId);
        this.fetchProjectMembers(projectId);
        this.fetchInvestors(projectId); // Pass projectId here
        this.$nextTick(() => {
          this.applyFiltersOnLoad();
        });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // Redirect to 404 page if not found
          this.$router.push({ name: "NotFound" });
        } else {
          console.error("Error fetching project data:", error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    enableEditName() {
      this.projectName = this.project.project_name;
      this.editingName = true;
    },
    enableEditDescription() {
      this.projectDescription = this.project.description;
      this.editingDescription = true;
    },
    async saveProjectName() {
      this.editingName = false;
      try {
        // Prepare the payload for the PATCH request
        const payload = {
          project_name: this.projectName,
          start_date: this.project.start_date,
          end_date: this.project.end_date,
          status: this.project.status,
          description: this.project.description,
        };

        // Send the PATCH request to update the project
        await apiClient.patch(
          `/web/projects/${this.project.project_id}`,
          payload
        );

        this.project.project_name = this.projectName;

        this.$toast.success("Project name updated successfully!");
      } catch (error) {
        console.error("Error updating project name:", error);
      }
    },
    async saveProjectDescription() {
      this.editingDescription = false;
      try {
        const payload = {
          project_name: this.project.project_name,
          start_date: this.project.start_date,
          end_date: this.project.end_date,
          status: this.project.status,
          description: this.projectDescription,
        };

        await apiClient.patch(
          `/web/projects/${this.project.project_id}`,
          payload
        );

        this.project.description = this.projectDescription;

        this.$toast.success("Project description updated successfully!");
      } catch (error) {
        console.error("Error updating project description:", error);
      }
    },
    async updateDate(field) {
      try {
        const payload = {
          project_name: this.project.project_name,
          start_date: this.project.start_date,
          end_date: this.project.end_date,
          status: this.project.status,
          description: this.project.description,
          [field]: this.project[field],
        };

        await apiClient.patch(
          `/web/projects/${this.project.project_id}`,
          payload
        );

        this.$toast.success(`${field.replace("_", " ")} updated successfully!`);
      } catch (error) {
        console.error(`Error updating ${field}:`, error);
        console.error(
          "Error updating project:",
          error.response ? error.response.data : error
        );
      }
    },
    handleTaskCreated(message) {
      this.$toast.success("Task created successfully!", message);
      this.fetchTasks(this.project.project_id);
    },

    async fetchTasks(projectId, start_date = null, end_date = null) {
      if (!projectId) return;

      try {
        const params = {};
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;

        const response = await apiClient.get(
          `/web/projects/${projectId}/tasks`,
          {
            params,
          }
        );
        // Create a new array to ensure Vue reactivity
        this.tasks = [...response.data.data];
      } catch (error) {
        console.error("Error fetching tasks data:", error);
      }
    },
    async fetchProjectMembers(projectId) {
      try {
        const response = await apiClient.get(
          `/web/projects/${projectId}/project_members/`
        );
        this.members = response.data.data;
      } catch (error) {
        console.error("Error fetching members data:", error);
      }
    },
    async fetchProjectTeams(projectId) {
      try {
        const url = `/web/teams/project/${projectId}?page=1&page_size=100`;

        const response = await apiClient.get(url);
        if (response.data && response.data.data) {
          this.teams = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching teams data:", error);
      }
    },
    async fetchTalents(projectId) {
      try {
        if (projectId === null) {
          return;
        }

        if (this.isAdmin || this.isManager) {
          const response = await apiClient.get("/web/talents", {
            params: { page_size: 100, project_id: projectId },
          });
          this.talents = response.data.data;
        } else if (this.isTalent) {
          const response = await apiClient.get("/web/talent/me");
          const talentData = response.data.data;
          this.talentId = talentData.talent_id;
          this.talentName = talentData.talent_first_name;
          this.talentEmail = talentData.talent_email;
          this.TaskAssignedTo = talentData.talent_id;
          this.talents = [
            {
              user: {
                first_name: talentData.talent_first_name,
                last_name: talentData.talent_last_name,
                email: talentData.talent_email,
              },
              talent_id: talentData.talent_id,
            },
          ];
        }
        console.log("talentId:", this.talentId);
      } catch (error) {
        console.error("Error fetching talents:", error);
      }
    },
    async fetchInvestors(projectId) {
      try {
        const response = await apiClient.get(
          `/web/investors?project_id=${projectId}`
        );
        this.investors = response.data.data.map((investor) => ({
          investorId: investor.investor_id,
          projectId: investor.project_id,
          isApproved: investor.is_approved,
          dateJoined: investor.date_joined,
          industry: investor.investor.industry || "N/A",
          name: `${investor.investor.user.first_name} ${investor.investor.user.last_name}`,
          email: investor.investor.user.email,
        }));
        console.log("Investors fetched:", this.investors);
      } catch (error) {
        console.error("Error fetching investors:", error);
      }
    },
    async fetchInvestorPercentages(projectId) {
      try {
        const response = await apiClient.get(
          `/web/investors/investment-percentage/${projectId}`
        );
        this.investorPercentages = response.data.data;
      } catch (error) {
        console.error("Error fetching investor percentages:", error);
      }
    },
    async approveInvestor(investor) {
      try {
        await apiClient.post(`/web/projects/request-update`, {
          project_id: this.project.project_id,
          investor_id: investor.investorId,
          status: "approve",
        });
        investor.isApproved = true;
        this.$toast.success(`${investor.name} has been approved successfully.`);
      } catch (error) {
        console.error("Error approving investor:", error);
        this.$toast.error("Failed to approve investor.");
      }
    },
    async denyInvestor(investor) {
      try {
        await apiClient.post(`/web/projects/request-update`, {
          project_id: this.project.project_id,
          investor_id: investor.investorId,
          status: "deny",
        });
        this.investors = this.investors.filter(
          (i) => i.investorId !== investor.investorId
        );
        this.$toast.success(`${investor.name} has been denied successfully.`);
      } catch (error) {
        console.error("Error denying investor:", error);
        this.$toast.error("Failed to deny investor.");
      }
    },
    clearErrorMessage() {
      console.log("Legacy: Clearing error message in parent component");
    },

    openCreateTaskModal(task = null) {
      this.prefilledTask = task;
      this.isTaskEdit = false;
      this.talentName =
        task && task.talent
          ? `${task.talent.first_name} ${task.talent.last_name}`
          : "";
      this.talentEmail = task && task.talent ? task.talent.email : "";
      this.teamName = task && task.team ? task.team.name : "";
      this.showCreateTaskModal = true;
      if (this.$refs.createTaskModal) {
        this.$refs.createTaskModal.clearErrorMessage(); // Use the ref to call the method
      }
    },
    openDuplicateTaskModal(task) {
      this.showCreateTaskModal = true;
      this.isTaskEdit = false;
      this.talentName =
        task && task.talent
          ? `${task.talent.first_name} ${task.talent.last_name}`
          : "";
      this.talentEmail = task && task.talent ? task.talent.email : "";
      this.teamName = task.team ? task.team.name : "";

      this.prefilledTask = task;
      if (this.$refs.createTaskModal) {
        this.$refs.createTaskModal.clearErrorMessage();
      }
    },
    openEditTaskModal(task) {
      this.showCreateTaskModal = true;
      this.isTaskEdit = true;
      console.log("Opening edit task modal for:", task); // Debugging

      this.talentName =
        task && task.talent
          ? `${task.talent.first_name} ${task.talent.last_name}`
          : "";
      this.talentEmail = task && task.talent ? task.talent.email : "";
      this.teamName = task.team ? task.team.name : "";
      this.prefilledTask = task;
      if (this.$refs.createTaskModal) {
        this.$refs.createTaskModal.clearErrorMessage();
      }
    },
    closeCreateTaskModal() {
      this.showCreateTaskModal = false;
      this.fetchTasks(this.project.project_id);
    },
    openRenameTaskModal(task) {
      this.selectedTaskForRename = task;
      this.showRenameTaskModal = true;
    },
    closeRenameTaskModal() {
      this.showRenameTaskModal = false;
      this.selectedTaskForRename = null;
    },

    handleMemberAddedSuccess(message) {
      this.showAddProjectMemberModal = false;
      this.$toast.success(message);

      this.fetchProjectMembers(this.project.project_id);
    },

    handleTaskError(message) {
      this.$toast.error(message);
    },
    closeTaskModal() {
      this.showTaskModal = false;
    },

    goToProgressReports(projectName) {
      if (!projectName) {
        console.error("Project name is undefined.");
        return;
      }
      this.$router.push({ name: "ProgressReports", params: { projectName } });
    },
    goToProjectActivities(projectId) {
      this.$router.push({ name: "ActivityData", params: { projectId } });
    },
    goToPublicProject(projectId, errorMessage = null) {
      if (errorMessage) {
        this.$store.dispatch('showErrorNotification', errorMessage);
      }
      this.$router.push({ name: "PublicProjectView", params: { projectId } });
    },
    async checkMembershipStatus() {
      try {
        const projectId = this.$route.params.projectId;
        const response = await apiClient.get(
          `/web/projects/${projectId}/membership-check`
        );
        const {
          isMember,
          isApproved,
          canJoinProject,
          canInvestProject,
          canCancelJoinRequest,
        } = response.data.data;

        this.canJoinProject = canJoinProject;
        this.isApprovedMember = isMember && isApproved;
        this.canInvestProject = canInvestProject;
        this.canCancelRequest = canCancelJoinRequest;

        if (!this.isApprovedMember) {
          this.goToPublicProject(projectId, "Unauthorized to view Project");
          return;
        }
      } catch (error) {
        console.error("Error checking membership status:", error);
        const projectId = this.$route.params.projectId;
        this.goToPublicProject(projectId);
      }
    },
    async cancelJoinRequest() {
      try {
        const projectId = this.$route.params.projectId;
        await apiClient.delete(`/web/projects/${projectId}/cancel-request`);
        this.$toast.success("Join request canceled successfully!");
        this.checkMembershipStatus();
      } catch (error) {
        console.error("Error canceling join request:", error);
      }
    },
    async fetchSeedBreakdown() {
      try {
        const projectId = this.$route.params.projectId;
        const response = await apiClient.get(
          `/web/wallet/inflow/summary/${projectId}`
        );
        const seedBreakdownData = response.data.data;
        this.totalSeed = seedBreakdownData.total_inflow;
        this.todaySeed = seedBreakdownData.daily_inflow;
        this.todaySeedPercentage = seedBreakdownData.percentage_change;
      } catch (error) {
        console.error("Error fetching seed breakdown data:", error);
      }
    },
    formatDateForDisplay(dateString) {
      if (!dateString) return "";

      // Handle both ISO strings and simple date strings
      const date = new Date(dateString);

      // Check if date is valid
      if (isNaN(date.getTime())) return dateString;

      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    saveFiltersToStorage() {
      const currentUser = this.$store.state.user;
      const userId = currentUser ? currentUser.user_id : "guest";

      const filters = {
        // talent: this.filters.talent,
        talentObj: this.selectedTalent
          ? JSON.stringify(this.selectedTalent)
          : null,
        startDate: this.startDate,
        endDate: this.endDate,
        // timeFilter: this.selectedTimeFilter.value,
      };

      localStorage.setItem(
        `task_filters_${userId}`,
        // `user_${userId}_project_${this.$route.params.projectId}_filters`,
        JSON.stringify(filters)
      );
    },
    loadFiltersFromStorage() {
      // Get current user ID from your Vuex
      const currentUser = this.$store.state.user;
      const userId = currentUser ? currentUser.user_id : "guest";
      const savedFilters = localStorage.getItem(`task_filters_${userId}`);
      if (savedFilters) {
        const filters = JSON.parse(savedFilters);
        // this.filters.talent = filters.talent;
        this.startDate = filters.startDate;
        this.endDate = filters.endDate;
        if (filters.talentObj) {
          this.selectedTalent = JSON.parse(filters.talentObj);
        }
        if (filters.timeFilter) {
          this.selectedTimeFilter =
            this.timeFilterOptions.find(
              (opt) => opt.value === filters.timeFilter
            ) || this.timeFilterOptions[0];
        }
      }
    },
    async fetchTaskLimit() {
      try {
        const projectId = this.$route.params.projectId;
        const response = await apiClient.get(`/web/limit/`, {
          params: { id: projectId, limit_type: "project", name: "task" },
        });
        this.taskLimit = response.data.data;
      } catch (error) {
        console.error("Error fetching task limit:", error);
      }
    },

    // Global filter storage methods
    saveGlobalFiltersToStorage() {
      const currentUser = this.$store.state.user;
      const userId = currentUser ? currentUser.user_id : "guest";
      const projectId = this.$route.params.projectId;

      const globalFilters = {
        globalSelectedTalent: this.globalSelectedTalent,
        globalSelectedTalentId: this.globalSelectedTalentId,
        globalStartDate: this.globalStartDate,
        globalEndDate: this.globalEndDate,
      };

      localStorage.setItem(
        `global_project_filters_${userId}_${projectId}`,
        JSON.stringify(globalFilters)
      );
    },

    loadGlobalFiltersFromStorage() {
      const currentUser = this.$store.state.user;
      const userId = currentUser ? currentUser.user_id : "guest";
      const projectId = this.$route.params.projectId;

      const savedFilters = localStorage.getItem(
        `global_project_filters_${userId}_${projectId}`
      );
      if (savedFilters) {
        const filters = JSON.parse(savedFilters);
        this.globalSelectedTalent = filters.globalSelectedTalent || null;
        this.globalSelectedTalentId = filters.globalSelectedTalentId || null;
        this.globalStartDate = filters.globalStartDate || "";
        this.globalEndDate = filters.globalEndDate || "";

        this.startDate = this.globalStartDate;
        this.endDate = this.globalEndDate;

        if (this.globalSelectedTalentId && this.members.length > 0) {
          const talent = this.members.find(
            (m) => m.talent_id === this.globalSelectedTalentId
          );
          if (talent) {
            this.selectedAssignee = talent;
          }
        }
      }
    },
  },
  async created() {
    if (!this.checkUserAccessAndRedirect()) {
      return;
    }

    const projectId = this.$route.params.projectId;

    await this.checkMembershipStatus();

    if (this.$route.name === "ProjectDetails") {
      await this.fetchTalents(projectId);

      this.fetchProject();
      this.fetchTalents(projectId);

      await this.fetchProjectMembers(projectId);
      this.loadGlobalFiltersFromStorage();

      this.fetchProjectRoles(projectId);
      this.fetchProjectSkills(projectId);
      this.fetchSeedBreakdown();
      this.fetchInvestors(projectId);
      this.fetchInvestorPercentages(projectId);
      this.loadFiltersFromStorage();
      this.fetchTaskLimit();

      // Get user ID for localStorage keys
      const userId = this.$store.state.user
        ? this.$store.state.user.user_id
        : "guest";

      this.$nextTick(() => {
        this.initTabStates();
      });

      this.cleanupOldTabPreferences();

      // Load selectedStatus from localStorage
      const savedStatus = localStorage.getItem(`user_${userId}_selectedStatus`);
      if (savedStatus) {
        try {
          this.selectedStatus = JSON.parse(savedStatus);
        } catch (e) {
          console.error("Error parsing selectedStatus from localStorage", e);
        }
      }

      // Load selectedAssignee from localStorage
      const savedAssignee = localStorage.getItem(
        `user_${userId}_selectedAssignee`
      );
      if (savedAssignee) {
        try {
          this.selectedAssignee = JSON.parse(savedAssignee);
        } catch (e) {
          console.error("Error parsing selectedAssignee from localStorage", e);
        }
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
    document.addEventListener("click", this.closeStatusDropdown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
    document.removeEventListener("click", this.closeStatusDropdown);

    // Clean up both storage listeners
    if (this.projectDetailsTabStorageListener) {
      window.removeEventListener(
        "storage",
        this.projectDetailsTabStorageListener
      );
    }
    if (this.investorTabStorageListener) {
      window.removeEventListener("storage", this.investorTabStorageListener);
    }
  },
};
</script>

<style scoped>
.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
